export default "__VITE_ASSET__BJI$QW9b__"